'use client'

import { FieldCopyable } from '~/components/component-library/Copyable/components/FieldCopyable'
import { StandardCopyable } from '~/components/component-library/Copyable/components/StandardCopyable'
import { CopyableProps } from '~/components/component-library/Copyable/types'

export type {
  CopyableProps,
  CopyableLayout,
  FieldCopyableProps,
  StandardCopyableProps,
} from '~/components/component-library/Copyable/types'

export const Copyable = (props: CopyableProps) =>
  props.layout === 'standard' ? (
    <StandardCopyable {...props} />
  ) : (
    <FieldCopyable {...props} />
  )
